var Marionette = require('backbone.marionette');

var RelationTypesCollection = require('../../collections/relation-types-collection');
var RelationType = require('../../models/relation-type-model');
var RelationTypeForm = require('./relationtype-form-view');
var RelationTypesListView = require('./relationtype-list-view');
var DboTypesCollection = require('../../collections/dbotypes-collection');

var RelationTypesList = Marionette.View.extend({
    template: require('../../templates/relationtypes/relationtypes.html'),
    collection: new RelationTypesCollection(),

    events: {
        'click #save-relationtype': 'saveRelationType',
        'keyup input#filter-relationtype': 'applyFilter'
    },

    regions: {
        modal: '#addRelationTypeModal',
        form: '#form',
        table: '#relationtypes-table'
    },

    collectionEvents: {
        add: 'itemAdded',
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    initialize: function(options){
        this.model = new RelationType();
        this.model.view = this;
        this.model.on('invalid', this.onErrors);
        _.bindAll(this, 'onRender', 'renderTable', 'itemSaved',
            'saveRelationType', 'applyFilter', 'onErrors');
    },

    onErrors: function(model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function(){
        var that = this;
        var dboTypes = new DboTypesCollection();
        dboTypes.fetch({success: function() {
            that.relationTypeForm = new RelationTypeForm({model: that.model, dboTypes: dboTypes});
            that.showChildView('form', that.relationTypeForm);
        }});
        that.collection.fetch({success: that.renderTable(that.collection)});
    },

    renderTable: function(collection){
        var that = this;
        that.showChildView('table', new RelationTypesListView({relationtypes: collection, filter: ''}));
    },

    saveRelationType: function () {
        var that = this;
        that.model = that.relationTypeForm.fillModel();
        that.model.save(that.model.toJSON(), {success: function(response) {
            that.itemSaved();
            $('#addRelationTypeModal').modal('hide');
        }
        });
    },

    itemAdded: function() {
        this.model = this.relationTypeForm.clearModel();
    },

    itemSaved: function(){
        this.collection.add(this.model.clone());
    },

    applyFilter: function(event) {
        var that = this;
        that.getChildView('table').setFilter(event.target.value);
    },

    showLoading: function() {
        this.$('.loading').show();
    },

    hideLoading: function() {
        this.$('.loading').hide();
    },

    logError: function(obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    }

});


module.exports = RelationTypesList;


//////////////////
// WEBPACK FOOTER
// ./app/views/relationtypes/relationtypes.js
// module id = 428
// module chunks = 0